import { merge, snakeCase } from 'lodash';
import { isActiveMilestonePay } from '../../../../reducers/workProcess';
import { PAGE_NAME } from '../../../bigQueryEventsData';
import { BASE_PARAMS } from '../constants';

export const activePaymentWorkProcessEventType = 'gig_page_milestone_payment_is_shown';
export const noActivePaymentWorkProcessEventType = 'gig_page_work_process_is_shown';

export const createWorkProcessComponentIsShown = () =>
    ({
        userId,
        pageCtxId,
        state,
        ...enrichmentParams
    } = {}) => merge({}, BASE_PARAMS, enrichmentParams, {
        type: isActiveMilestonePay(state)
            ? activePaymentWorkProcessEventType
            : noActivePaymentWorkProcessEventType,
        event_source: snakeCase(PAGE_NAME),
        user: { id: userId },
        page: merge({}, {
            ctx_id: pageCtxId,
            name: PAGE_NAME
        })
    });
